import { useState } from "react";
import { Box, Divider, Grid, IconButton, Stack, TextField, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ReactSortable } from "react-sortablejs";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import DayPicker from "Components/DayPicker";
import { deselectStation, setStations } from "Redux/stationsSlice";
import DatePicker from "Components/DatePicker";
import { changeSurveysFilter } from "Redux/filtersSlice";
import TimePicker from "Components/TimePicker";
import { TRIP_TYPES_DATA2, VEHICLE_TYPES_DATA } from "Constants/Survey";
import type { IStepProps } from ".";

export default function General() {
  // Type dataTpe { [key: string]: any } | null;
  const { stations } = useAppSelector((state) => state.stations);
  const [gender, setGender] = useState<string | null>("");
  const [data, setData] = useState<{ [key: string]: any } | null>({});
  const { surveys } = useAppSelector((state) => state.filters);
  const dispatch = useAppDispatch();

  const handleSetData = (key: string, value: any) => {
    //  { ...stepData, [key]: value }
    setData({ ...data, [key]: value });
  };

  // const stepData = data?.general || null;

  const handleGender = (event: React.MouseEvent<HTMLElement>, newAlignment: string | null) => {
    setGender(newAlignment);
  };

  const handleSetDateRange = (obj: any) => {
    dispatch(changeSurveysFilter(obj));
  };

  const handleSetFilter = (key: string, value: any) => {
    if (value) {
      dispatch(changeSurveysFilter({ [key]: value }));
    }
  };

  return (
    <>
      <Grid container columnSpacing={1} sx={{ alignItems: "center", mb: "20px" }}>
        <Grid item xs={2.6}>
          <TextField
            label="شماره موبایل"
            fullWidth
            onChange={(e) => handleSetData("mobile", e.target.value)}
            value={data?.mobile || ""}
          />
        </Grid>
        <Grid item xs={2.9}>
          <TextField
            label="نام و نام خانوادگی"
            fullWidth
            onChange={(e) => handleSetData("first_name", e.target.value)}
            value={data?.first_name || ""}
          />
        </Grid>
        <Grid item xs={1.7}>
          <ToggleButtonGroup value={gender} exclusive onChange={handleGender} aria-label="gender">
            <ToggleButton
              value="man"
              aria-label="man"
              style={{
                backgroundColor: gender === "man" ? "#4754CA" : "",
                color: gender === "man" ? "#fff" : "",
                padding: "15px",
                minWidth: "50%",
              }}
            >
              مرد
            </ToggleButton>
            <ToggleButton
              value="woman"
              aria-label="woman"
              style={{
                backgroundColor: gender === "woman" ? "#4754CA" : "",
                color: gender === "woman" ? "#fff" : "",
                padding: "15px",
                minWidth: "50%",
              }}
            >
              زن
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
        <Grid item xs={12} md={2.4}>
          <TimePicker
            label=" ساعت رسیدن"
            name="go_after"
            data={surveys}
            setData={(value) => handleSetFilter("go_after", value)}
          />
        </Grid>
        <Grid item xs={12} md={2.4}>
          <TimePicker
            label=" ساعت برگشت "
            name="return_before"
            data={surveys}
            setData={(value) => handleSetFilter("return_before", value)}
          />
        </Grid>
      </Grid>
      {/* <Divider sx={{ my: 2 }} /> */}
      <Grid container columnSpacing={1} sx={{ alignItems: "center", mb: "20px" }}>
        <Grid item xs={5.7}>
          <Typography mb={1}>روزهای فعالیت</Typography>
          <DayPicker
            label="روزهای فعالیت"
            multiple
            padding="15px 14px"
            minWidth={50}
            isGeneral={true}
            value={data?.working_days || []}
            setData={(value) => handleSetData("working_days", value)}
          />
        </Grid>
        <Grid item xs={6.3}>
          <Typography mb={1}>نوع سفر</Typography>
          <ToggleButtonGroup value={gender} exclusive onChange={handleGender} aria-label="gender">
            {Object.keys(TRIP_TYPES_DATA2).map((key) => {
              return (
                <ToggleButton
                  value="man"
                  aria-label="man"
                  style={{
                    backgroundColor: gender === "man" ? "#4754CA" : "",
                    color: gender === "man" ? "#fff" : "",
                    padding: "15px 14px",
                    // minWidth: "50%",
                  }}
                >
                  {TRIP_TYPES_DATA2[key as keyof typeof TRIP_TYPES_DATA2].text}
                </ToggleButton>
              );
            })}
          </ToggleButtonGroup>
        </Grid>
      </Grid>

      <Grid container columnSpacing={1} sx={{ alignItems: "center" }}>
        <Grid item xs={12}>
          <Typography mb={1}>نوع وسیله نقلیه مورد نیاز</Typography>
          <ToggleButtonGroup value={gender} exclusive onChange={handleGender} aria-label="gender">
            {Object.keys(VEHICLE_TYPES_DATA)
              .reverse()
              .map((key) => {
                return (
                  <ToggleButton
                    value="man"
                    aria-label="man"
                    style={{
                      backgroundColor: gender === "man" ? "#4754CA" : "",
                      color: gender === "man" ? "#fff" : "",
                      padding: "10px",
                      // minWidth: "50%",
                      fontSize: "13px",
                    }}
                  >
                    {VEHICLE_TYPES_DATA[key as keyof typeof VEHICLE_TYPES_DATA].name}
                  </ToggleButton>
                );
              })}
          </ToggleButtonGroup>
        </Grid>
      </Grid>
    </>
  );
}
